import { memo } from "react";
import classNames from "classnames";
import InnerHTML from "dangerously-set-html-content";
import deepEqual from "fast-deep-equal";
import { useHeadContent } from "./useHeadContent";

export interface DirectHTMLRendererProps {
  body?: string;
  head?: string;
  isPreviewMode?: boolean;
}

const DirectHTMLRendererComponent = ({
  head,
  body,
  isPreviewMode,
}: DirectHTMLRendererProps) => {
  const setContainer = useHeadContent(head);

  return (
    <div ref={setContainer} data-testid="custom-html-renderer-container">
      {body && (
        <InnerHTML
          html={body}
          // @ts-expect-error -- The InnerHTML module is incorrectly typed, this is a valid prop
          allowRerender
          data-testid="custom-html-renderer-body"
          className={classNames({
            "wb-pointer-events-none": isPreviewMode,
          })}
        />
      )}
    </div>
  );
};

DirectHTMLRendererComponent.displayName = "DirectHTMLRenderer";

export const DirectHTMLRenderer = memo(DirectHTMLRendererComponent, deepEqual);
